import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=ce79cbda&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce79cbda')) {
      api.createRecord('ce79cbda', component.options)
    } else {
      api.reload('ce79cbda', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=ce79cbda&", function () {
      api.rerender('ce79cbda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gIk3TBjULCZv/JS/comp/childrenage.vue"
export default component.exports